"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var button_style_component_1 = require("./button.style.component");
exports.Button = function (_a) {
    var icon = _a.icon, onClick = _a.onClick, testID = _a.testID, children = _a.children, className = _a.className, disabled = _a.disabled, withEllipsis = _a.withEllipsis, type = _a.type;
    return (
    // eslint-disable-next-line react/forbid-elements
    react_1.default.createElement("button", { type: type, onClick: onClick, className: className, disabled: disabled, "data-test-id": testID },
        icon && react_1.default.createElement(button_style_component_1.ButtonIcon, null, icon),
        withEllipsis ? react_1.default.createElement(button_style_component_1.ButtonTextWrapper, null, children) : children));
};
exports.Button.displayName = 'Button';
exports.PrimaryButton = styled_components_1.default(exports.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  background: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  ", ";\n  color: ", ";\n  background: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), button_style_component_1.baseButtonStyles, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.text;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.background;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.backgroundHover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.backgroundFocus;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.disabledText;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.primary.disabledBackground;
});
exports.PrimaryButton.displayName = 'PrimaryButton';
exports.SecondaryButton = styled_components_1.default(exports.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  background: none;\n  border: 1px solid ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    border-color: ", ";\n    background: none;\n  }\n"], ["\n  ", ";\n  color: ", ";\n  background: none;\n  border: 1px solid ", ";\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    border-color: ", ";\n    background: none;\n  }\n"])), button_style_component_1.baseButtonStyles, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.color;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.color;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.backgroundHover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.backgroundFocus;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.disabledText;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.secondary.disabledBorder;
});
exports.SecondaryButton.displayName = 'SecondaryButton';
exports.AlarmButton = styled_components_1.default(exports.Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  background: ", ";\n  border: 0;\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  ", ";\n  color: ", ";\n  background: ", ";\n  border: 0;\n  &:hover {\n    background-color: ", ";\n  }\n  &:focus {\n    background-color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), button_style_component_1.baseButtonStyles, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.text;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.background;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.backgroundHover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.backgroundFocus;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.disabledText;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.alarm.disabledBackground;
});
exports.AlarmButton.displayName = 'AlarmButton';
exports.TextButton = styled_components_1.default(exports.Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  min-width: unset;\n  color: ", ";\n  text-decoration: ", ";\n  text-transform: ", ";\n  height: ", ";\n  font-weight: ", ";\n  background: none;\n  padding: 0;\n  border: 0;\n  max-width: ", ";\n  &:hover:not(:disabled) {\n    background: none;\n    text-decoration: ", ";\n  }\n  &:focus {\n    outline: none;\n    background: none;\n  }\n  &:disabled {\n    cursor: not-allowed;\n    background: none;\n    color: ", ";\n  }\n"], ["\n  ", ";\n  min-width: unset;\n  color: ",
    ";\n  text-decoration: ", ";\n  text-transform: ", ";\n  height: ", ";\n  font-weight: ", ";\n  background: none;\n  padding: 0;\n  border: 0;\n  max-width: ", ";\n  &:hover:not(:disabled) {\n    background: none;\n    text-decoration: ", ";\n  }\n  &:focus {\n    outline: none;\n    background: none;\n  }\n  &:disabled {\n    cursor: not-allowed;\n    background: none;\n    color: ", ";\n  }\n"])), button_style_component_1.baseButtonStyles, function (_a) {
    var colours = _a.theme.colours, primaryColor = _a.primaryColor;
    return primaryColor ? colours.button.text.color : colours.button.secondary.color;
}, function (_a) {
    var isUnderlined = _a.isUnderlined;
    return (isUnderlined ? 'underline' : 'none');
}, function (_a) {
    var hasNormalText = _a.hasNormalText;
    return (hasNormalText ? 'none' : 'uppercase');
}, function (_a) {
    var isUnderlined = _a.isUnderlined, isHeightAuto = _a.isHeightAuto;
    return (isUnderlined || isHeightAuto ? 'auto' : '');
}, function (_a) {
    var isUnderlined = _a.isUnderlined;
    return (isUnderlined ? 'normal' : '');
}, function (_a) {
    var withEllipsis = _a.withEllipsis;
    return (withEllipsis ? '100%' : 'unset');
}, function (_a) {
    var isUnderlined = _a.isUnderlined;
    return (isUnderlined ? 'none' : '');
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.button.text.disabled;
});
exports.TextButton.displayName = 'TextButton';
exports.default = exports.PrimaryButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=button.component.js.map